import Vue from 'vue'
import Vuex from 'vuex'

import { ref } from './ref';
import { user } from './user';
import { registration } from './registration';
import { officerConfig } from './officerConfig';
import { questionnaire } from './questionnaire';
import { keycloak } from './keycloak';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    ref,
    user,
    registration,
    officerConfig,
    questionnaire,
    keycloak,
  }
})
